// src/platform/pwa/offlineManager.js



import eventBus

  from '@/platform/core/eventBus'



import logger

  from '@/platform/core/logger'





const CONNECTIVITY_STORAGE_KEY =

  'nexgbits.connectivity'





const HEALTH_PROBE_URL =

  '/api/health'



const HEALTH_PROBE_TIMEOUT_MS =

  4000





const RECOVERY_PROBE_INTERVAL_MS = 15000

class OfflineManager {

  constructor() {

    this.initialized =

      false



    this.isOnline =

      typeof navigator !==

        'undefined'

        ? navigator.onLine

        : true



    /*

     * Records whether the last state was established by an

     * actual network/API failure rather than navigator.onLine.

     *

     * This matters because browsers may temporarily continue

     * reporting navigator.onLine === true even though requests

     * cannot reach the backend.

     */

    this.networkFailureDetected =

      false



    this.lastChangedAt =

      null



    this.lastReason =

      'initial'



    /*

     * Only one backend connectivity confirmation should run at a

     * time. Multiple failing business requests can otherwise launch

     * several simultaneous health probes and race the connectivity

     * state.

     */

    this.healthProbePromise =

      null



    this.healthProbeSequence =

      0

    this.recoveryTimer = null



    this.handleOnline =

      this.handleOnline.bind(

        this

      )



    this.handleOffline =

      this.handleOffline.bind(

        this

      )

  }





 // ==========================================================

// INITIALIZE

// ==========================================================



init() {

  if (

    this.initialized ||

    typeof window ===

      'undefined'

  ) {

    return

  }



  /*

   * Initial connectivity comes directly from the browser.

   *

   * Do NOT restore connectivity from storage.

   * Connectivity is runtime state, not persisted application state.

   */

  this.isOnline =

    typeof navigator !==

      'undefined'

      ? navigator.onLine

      : true



  this.networkFailureDetected =

    this.isOnline ===

      false



  this.lastReason =

    this.isOnline

      ? 'initial-browser-online'

      : 'initial-browser-offline'



  this.lastChangedAt =

    new Date()

      .toISOString()



  window.addEventListener(

    'online',

    this.handleOnline

  )



  window.addEventListener(

    'offline',

    this.handleOffline

  )



  // Retry connectivity independently of terminal-loading requests.
    this.recoveryTimer = window.setInterval(() => {
      if (typeof navigator !== 'undefined' && !navigator.onLine) return
      if (!this.isOnlineNow()) {
        void this.verifyBackendConnectivity('periodic-recovery-check')
      }
    }, RECOVERY_PROBE_INTERVAL_MS)

    this.initialized = true



  logger.info(

    'Offline manager initialized.',

    {

      isOnline:

        this.isOnline,



      networkFailureDetected:

        this.networkFailureDetected,



      reason:

        this.lastReason

    }

  )



  this.emitStatus(

    this.lastReason

  )

}





  // ==========================================================

  // LOAD PERSISTED CONNECTIVITY

  // ==========================================================



  // loadPersistedState() {

  //   if (

  //     typeof sessionStorage ===

  //       'undefined'

  //   ) {

  //     return null

  //   }



  //   try {

  //     const raw =

  //       sessionStorage.getItem(

  //         CONNECTIVITY_STORAGE_KEY

  //       )



  //     if (!raw) {

  //       return null

  //     }



  //     const parsed =

  //       JSON.parse(

  //         raw

  //       )



  //     if (

  //       typeof parsed?.isOnline !==

  //         'boolean'

  //     ) {

  //       return null

  //     }



  //     return parsed

  //   }

  //   catch {

  //     return null

  //   }

  // }





  // ==========================================================

  // PERSIST CONNECTIVITY

  // ==========================================================



  // persistState() {

  //   if (

  //     typeof sessionStorage ===

  //       'undefined'

  //   ) {

  //     return

  //   }



  //   try {

  //     sessionStorage.setItem(

  //       CONNECTIVITY_STORAGE_KEY,

  //       JSON.stringify({

  //         isOnline:

  //           this.isOnline,



  //         networkFailureDetected:

  //           this.networkFailureDetected,



  //         reason:

  //           this.lastReason,



  //         updatedAt:

  //           this.lastChangedAt

  //       })

  //     )

  //   }

  //   catch {

  //     /*

  //      * Connectivity persistence must never break the

  //      * application.

  //      */

  //   }

  // }





  // ==========================================================

  // DESTROY

  // ==========================================================



  destroy() {

    if (

      !this.initialized ||

      typeof window ===

        'undefined'

    ) {

      return

    }



    window.removeEventListener(

      'online',

      this.handleOnline

    )



    window.removeEventListener(

      'offline',

      this.handleOffline

    )



    if (this.recoveryTimer !== null) {
      window.clearInterval(this.recoveryTimer)
      this.recoveryTimer = null
    }

    this.healthProbeSequence++



    this.healthProbePromise =

      null



    this.initialized =

      false



    logger.info(

      'Offline manager destroyed.'

    )

  }





  // ==========================================================

  // BROWSER ONLINE EVENT

  // ==========================================================



  handleOnline() {

    /*

     * A browser "online" event means a network interface has

     * become available.

     *

     * Clear a previous transport-failure state and allow API

     * calls to verify real connectivity.

     */

    this.networkFailureDetected =

      false



    this.setState(

      true,

      'browser-online'

    )

  }





  // ==========================================================

  // BROWSER OFFLINE EVENT

  // ==========================================================



  handleOffline() {

    this.networkFailureDetected =

      true



    this.setState(

      false,

      'browser-offline'

    )

  }





  // ==========================================================

// SET STATE

// ==========================================================



setState(

  online,

  reason = 'state-change'

) {

  const nextState =

    Boolean(

      online

    )



  const previous =

    this.isOnline



  this.isOnline =

    nextState



  this.lastReason =

    reason



  this.lastChangedAt =

    new Date()

      .toISOString()



  /*

   * Connectivity is deliberately NOT persisted.

   *

   * It represents the current runtime network state.

   */

  if (

    previous ===

    this.isOnline

  ) {

    this.emitStatus(

      reason

    )



    return

  }



  if (

    this.isOnline

  ) {

    logger.info(

      'Application is online.',

      {

        reason

      }

    )

  }

  else {

    logger.warn(

      'Application is offline.',

      {

        reason

      }

    )

  }



  this.emitStatus(

    reason

  )

}





  // ==========================================================

  // REPORT NETWORK FAILURE

  //

  // Call this when Axios/fetch cannot reach the backend.

  //

  // IMPORTANT:

  // A single failed business request is NOT enough to declare the

  // POS offline while the browser still reports an available

  // network interface.

  //

  // Rules:

  //

  // 1. navigator.onLine === false

  //      -> immediately confirm Offline.

  //

  // 2. navigator.onLine === true

  //      -> probe GET /api/health.

  //

  // 3. health probe succeeds

  //      -> remain Online.

  //

  // 4. health probe also fails

  //      -> confirm Offline.

  //

  // Return value is intentionally kept boolean for compatibility

  // with existing POS callers. While a health probe is pending we

  // return false so callers MUST NOT immediately switch into their

  // offline transaction path.

  // ==========================================================



  reportNetworkFailure(

    error = null,

    reason = 'network-request-failed'

  ) {

    if (

      !this.isNetworkError(

        error

      )

    ) {

      return false

    }



    /*

     * The browser has definitive evidence that no network

     * interface is available. No backend probe is useful here.

     */

    if (

      typeof navigator !==

        'undefined' &&

      navigator.onLine ===

        false

    ) {

      this.networkFailureDetected =

        true



      this.setState(

        false,

        'browser-offline'

      )



      logger.warn(

        'Network failure confirmed by browser offline state.',

        {

          reason,



          code:

            error?.code

            ??

            null,



          message:

            error?.message

            ??

            null

        }

      )



      return true

    }



    /*

     * Browser still reports Online. Do not flip the global POS

     * state yet. Confirm against the Nexgbits API health endpoint.

     */

    this.verifyBackendConnectivity(

      reason

    )



    logger.warn(

      'Network request failed. Verifying Nexgbits API health before switching offline.',

      {

        reason,



        healthProbeUrl:

          HEALTH_PROBE_URL,



        code:

          error?.code

          ??

          null,



        message:

          error?.message

          ??

          null

      }

    )



    return false

  }





  // ==========================================================

  // VERIFY BACKEND CONNECTIVITY

  //

  // Uses the Nexgbits ASP.NET Core anonymous health endpoint:

  //

  //   GET /api/health

  //

  // The probe deliberately uses the browser Fetch API rather than

  // the application's Axios instance so authentication interceptors,

  // refresh-token handlers, or business-request interceptors cannot

  // turn the health confirmation into another false offline signal.

  // ==========================================================



  async verifyBackendConnectivity(

    failureReason =

      'network-request-failed'

  ) {

    /*

     * Browser explicitly reports Offline.

     */

    if (

      typeof navigator !==

        'undefined' &&

      navigator.onLine ===

        false

    ) {

      this.networkFailureDetected =

        true



      this.setState(

        false,

        'browser-offline'

      )



      return false

    }



    /*

     * Reuse an active probe instead of creating several parallel

     * requests when multiple API calls fail at the same time.

     */

    if (

      this.healthProbePromise

    ) {

      return this.healthProbePromise

    }



    const probeSequence =

      ++this.healthProbeSequence



    this.healthProbePromise =

      this.executeHealthProbe(

        probeSequence,

        failureReason

      )



    try {

      return await this.healthProbePromise

    }

    finally {

      if (

        probeSequence ===

        this.healthProbeSequence

      ) {

        this.healthProbePromise =

          null

      }

    }

  }





  // ==========================================================

  // EXECUTE HEALTH PROBE

  // ==========================================================



  async executeHealthProbe(

    probeSequence,

    failureReason

  ) {

    if (

      typeof fetch !==

        'function'

    ) {

      /*

       * Browser environments used by the POS provide fetch.

       * If it is unavailable, do not guess Offline solely because

       * one business request failed.

       */

      logger.warn(

        'Backend health probe could not run because fetch is unavailable.',

        {

          failureReason

        }

      )



      return this.isOnlineNow()

    }



    const controller =

      typeof AbortController !==

        'undefined'

        ? new AbortController()

        : null



    let timeoutId =

      null



    if (

      controller &&

      typeof window !==

        'undefined'

    ) {

      timeoutId =

        window.setTimeout(

          () => {

            controller.abort()

          },

          HEALTH_PROBE_TIMEOUT_MS

        )

    }



    try {

      const response =

        await fetch(

          HEALTH_PROBE_URL,

          {

            method:

              'GET',



            cache:

              'no-store',



            credentials:

              'same-origin',



            headers: {

              Accept:

                'application/json'

            },



            signal:

              controller?.signal

          }

        )



      /*

       * Ignore a stale probe result if a newer verification was

       * started after this one.

       */

      if (

        probeSequence !==

        this.healthProbeSequence

      ) {

        return this.isOnlineNow()

      }



      if (

        response.ok

      ) {

        this.networkFailureDetected =

          false



        this.setState(

          true,

          'nexgbits-health-probe-success'

        )



        logger.info(

          'Nexgbits API health probe succeeded. POS remains online.',

          {

            status:

              response.status,



            failureReason

          }

        )



        return true

      }



      /*

       * The health endpoint itself responded. That proves the

       * Nexgbits API is reachable even if the status is unexpected.

       * Do not classify this as a transport/offline condition.

       */

      this.networkFailureDetected =

        false



      this.setState(

        true,

        'nexgbits-health-probe-http-response'

      )



      logger.warn(

        'Nexgbits API health probe returned a non-success HTTP response, but the API is reachable.',

        {

          status:

            response.status,



          failureReason

        }

      )



      return true

    }

    catch (probeError) {

      if (

        probeSequence !==

        this.healthProbeSequence

      ) {

        return this.isOnlineNow()

      }



      /*

       * Re-check browser state after the probe. If it went offline

       * during the request, use the explicit browser reason.

       */

      const browserOffline =

        typeof navigator !==

          'undefined' &&

        navigator.onLine ===

          false



      this.networkFailureDetected =

        true



      this.setState(

        false,

        browserOffline

          ? 'browser-offline'

          : 'nexgbits-health-probe-failed'

      )



      logger.warn(

        'Nexgbits API health probe failed. POS is confirmed offline.',

        {

          failureReason,



          healthProbeUrl:

            HEALTH_PROBE_URL,



          timeoutMs:

            HEALTH_PROBE_TIMEOUT_MS,



          name:

            probeError?.name

            ??

            null,



          message:

            probeError?.message

            ??

            null

        }

      )



      return false

    }

    finally {

      if (

        timeoutId !==

          null &&

        typeof window !==

          'undefined'

      ) {

        window.clearTimeout(

          timeoutId

        )

      }

    }

  }





  // ==========================================================

  // REPORT NETWORK SUCCESS

  //

  // A successful backend response can re-establish online

  // status.

  //

  // However, it must never override an explicit browser

  // Offline state.

  // ==========================================================



  reportNetworkSuccess(

    reason = 'network-request-success'

  ) {

    /*

     * Browser explicitly reports Offline.

     *

     * A stale/cached/late HTTP result must not change the

     * application back to Online.

     */

    if (

      typeof navigator !==

        'undefined' &&

      navigator.onLine ===

        false

    ) {

      this.networkFailureDetected =

        true



      this.setState(

        false,

        'browser-offline'

      )



      return false

    }



    /*

     * An actual successful backend request confirms that the

     * application is Online.

     */

    this.networkFailureDetected =

      false



    this.setState(

      true,

      reason

    )



    return true

  }





  // ==========================================================

  // NETWORK ERROR DETECTION

  // ==========================================================



  isNetworkError(

    error

  ) {

    /*

     * Explicit browser state is enough.

     */

    if (

      typeof navigator !==

        'undefined' &&

      navigator.onLine ===

        false

    ) {

      return true

    }



    if (!error) {

      return false

    }



    /*

     * Axios transport/network errors normally have no HTTP

     * response.

     *

     * Do NOT classify real HTTP responses such as 400, 401,

     * 403 or 409 as offline.

     */

    if (

      error.response !==

        undefined &&

      error.response !==

        null

    ) {

      return false

    }



    const code =

      String(

        error.code

        ??

        ''

      )

        .trim()

        .toUpperCase()



    const message =

      String(

        error.message

        ??

        ''

      )

        .trim()

        .toUpperCase()



    const name =

      String(

        error.name

        ??

        ''

      )

        .trim()

        .toUpperCase()



    if (

      [

        'ERR_NETWORK',

        'ECONNABORTED',

        'ECONNREFUSED',

        'ECONNRESET',

        'ENETUNREACH',

        'EHOSTUNREACH',

        'ETIMEDOUT',

        'ERR_INTERNET_DISCONNECTED'

      ].includes(

        code

      )

    ) {

      return true

    }



    if (

      [

        'NETWORKERROR',

        'TYPEERROR'

      ].includes(

        name

      ) &&

      (

        message.includes(

          'FETCH'

        ) ||

        message.includes(

          'NETWORK'

        ) ||

        message.includes(

          'LOAD FAILED'

        )

      )

    ) {

      return true

    }



    return (

      message.includes(

        'NETWORK ERROR'

      ) ||

      message.includes(

        'FAILED TO FETCH'

      ) ||

      message.includes(

        'ERR_INTERNET_DISCONNECTED'

      ) ||

      message.includes(

        'NETWORK REQUEST FAILED'

      ) ||

      message.includes(

        'LOAD FAILED'

      )

    )

  }





  // ==========================================================

  // EMIT STATUS

  // ==========================================================



  emitStatus(

    reason = 'status'

  ) {

    const status = {

      isOnline:

        this.isOnline,



      isOffline:

        !this.isOnline,



      reason,



      networkFailureDetected:

        this.networkFailureDetected,



      lastChangedAt:

        this.lastChangedAt,



      timestamp:

        new Date()

          .toISOString()

    }



    eventBus.emit(

      'platform.offline.changed',

      status

    )



    if (

      this.isOnline

    ) {

      eventBus.emit(

        'platform.online',

        status

      )

    }

    else {

      eventBus.emit(

        'platform.offline',

        status

      )

    }

  }





  // ==========================================================

  // IS ONLINE

  // ==========================================================



  isOnlineNow() {

    /*

     * If an actual network request has already established that

     * connectivity is unavailable, do not allow navigator.onLine

     * to override that result.

     */

    if (

      this.networkFailureDetected

    ) {

      return false

    }



    if (

      typeof navigator !==

        'undefined' &&

      navigator.onLine ===

        false

    ) {

      return false

    }



    return this.isOnline

  }





  // ==========================================================

  // IS OFFLINE

  // ==========================================================



  isOfflineNow() {

    return !this.isOnlineNow()

  }





  // ==========================================================

  // REFRESH FROM BROWSER

  //

  // Important:

  //

  // navigator.onLine=true does NOT override a network failure.

  //

  // Only an actual successful backend request should clear a

  // confirmed transport failure.

  // ==========================================================



  refresh() {

    if (

      typeof navigator ===

        'undefined'

    ) {

      return this.isOnlineNow()

    }



    const browserOnline =

      navigator.onLine



    if (

      browserOnline ===

      false

    ) {

      this.networkFailureDetected =

        true



      this.setState(

        false,

        'manual-browser-offline'

      )



      return false

    }



    /*

     * Do not change to online when we already know an actual

     * network request failed.

     */

    if (

      this.networkFailureDetected

    ) {

      this.setState(

        false,

        'manual-network-failure-retained'

      )



      void this.verifyBackendConnectivity('manual-recovery-check')
      return false

    }



    /*

     * Browser reports an available network interface and no

     * transport failure is currently known.

     */

    this.setState(

      true,

      'manual-browser-online'

    )



    return true

  }





  // ==========================================================

  // FORCE OFFLINE

  //

  // Useful when a feature has definitive evidence that the

  // backend cannot be reached.

  // ==========================================================



  markOffline(

    reason = 'application-offline'

  ) {

    this.networkFailureDetected =

      true



    this.setState(

      false,

      reason

    )



    return false

  }





  // ==========================================================

  // FORCE ONLINE

  //

  // Use only after a successful network/backend request.

  //

  // Explicit browser Offline state always wins.

  // ==========================================================



  markOnline(

    reason = 'application-online'

  ) {

    if (

      typeof navigator !==

        'undefined' &&

      navigator.onLine ===

        false

    ) {

      this.networkFailureDetected =

        true



      this.setState(

        false,

        'browser-offline'

      )



      return false

    }



    this.networkFailureDetected =

      false



    this.setState(

      true,

      reason

    )



    return true

  }





  // ==========================================================

  // STATUS

  // ==========================================================



  getStatus() {

    return {

      initialized:

        this.initialized,



      isOnline:

        this.isOnlineNow(),



      isOffline:

        this.isOfflineNow(),



      browserOnline:

        typeof navigator !==

          'undefined'

          ? navigator.onLine

          : true,



      networkFailureDetected:

        this.networkFailureDetected,



      reason:

        this.lastReason,



      lastChangedAt:

        this.lastChangedAt

    }

  }

}





const offlineManager =

  new OfflineManager()





export default offlineManager